import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';

import { formatCpf, unformatNumber } from '../../utils/formatters';

class CpfField extends Component {
  constructor(props) {
    super(props);

    this.onChange = (value) => {
      const { onChange } = this.props;
      onChange(unformatNumber(value));
    };
  }

  render() {
    const { onChange, value, ...props } = this.props;

    return (
      <TextField
        {...props}
        inputMode='numeric'
        onChange={this.onChange}
        value={formatCpf(value)}
      />
    );
  }
}

CpfField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CpfField.defaultProps = {
  onChange: () => {},
  value: '',
};

export default CpfField;
